export const Z_INDEXES = {
  hover: '1',
  active: '2',
  focus: '3',

  badge: '10',

  loader: '990',  
  dropdown: '1000',
  sticky_menu: '1020',
  fixed_menu: '1030',
  backdrop: '1040',
  off_canvas: '1050',
  modal: '1060',
  toast: '1070',
  tooltip: '1080',
  popover: '1070'
}
